import Link from '@atoms/Link';
import { envsEnum } from '@helpers/env-enum';

export const detailedBlogBreadcrumbs = (blogName) => [
    { title: 'Home', url: '/' },
    {
        title: 'Blogs',
        url: '/blogs',
    },
    { title: blogName, active: true },
];

export const blogBreadcrumbs = () => [
    { title: 'Home', url: '/' },
    {
        title: 'Blogs',
        active: true,
    },
];

export const getBreadCrumbs = (breadcrumbElements) => {
    return breadcrumbElements.map((breadcrumb, index) => (
        <Link
            key={index}
            label={breadcrumb.title}
            href={`${breadcrumb.active ? '#' : breadcrumb.url}`}
            active={breadcrumb.active}
        ></Link>
    ));
};

export const getBlogImageUrlUpdated = (url) => {
    const urlToReplace = process.env.NEXT_PUBLIC_CURRENT_ENV === envsEnum.PRODUCTION ? 'https://blog.jiraaf.com/wp-content/uploads' : 'https://uatblogs.jiraaf.com/wp-content/uploads';
    const newUrl = process.env.NEXT_PUBLIC_CURRENT_ENV === envsEnum.PRODUCTION ? '/blogs/wp-content' : '/uat-blogs/wp-content';
    // replace https://blog.jiraaf.com/wp-content/uploads to /blogs/wp-content from url
    return url?.replace(urlToReplace, newUrl);
}
